export const setTargetToRedux = target => {
    return {
        type:"SET_TARGET",
        payload:target,
    }
}
export const setRegions = regions => {
    return {
        type:"SET_REGIONS",
        payload:regions,
    }
}
export const setDistricts = districts => {
    return {
        type:"SET_DISTRICTS",
        payload:districts,
    }
}
